// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3w5hH","checkboxCol":"Table_checkboxCol__RlMiv","emailCol":"Table_emailCol__1KBwa","actionCol":"Table_actionCol__13r5_"};